import LockTableCellRenderer from "./LockTableCellRenderer";

export default class LeaveNameCellRenderer extends LockTableCellRenderer {
    generateContent(cell) {
        cell.getCellEl().innerHTML = ["<span class='lockTableEllipsis'>", cell.getValue(), "</span>"].join("");
    }

    getTopBorderClassName(cell) {
        if (cell.getRow().isFirstChildRow())
            return "detailsRowSeparator";
        else
            return "leaveNameTopBorder";
    }

    getComplicatedBorderClassName(cell) {
        var firstRow = cell.getRow().isFirstChildRow();
        var lastRow = cell.getRow().isLastChildRow();
        if (firstRow || lastRow)
            return (firstRow && lastRow) ? "singleDetailsRow" :
                   (firstRow ? "firstDetailsRow" : "lastDetailsRow");
        else
            return "";
    }

    getCellClassName(cell) {
        return "leaveNameCell";
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/LeaveNameCellRenderer.js